import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Search_md = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.BgColor ? "0 0 105 104" : "0 0 20 20"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            {props.BgColor ? <rect x="0.5" width="104" height="104" rx="50" fill={props.BgColor} /> : null}
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M8.83333 3.75C6.02589 3.75 3.75 6.02589 3.75 8.83333C3.75 11.6408 6.02589 13.9167 8.83333 13.9167C11.6408 13.9167 13.9167 11.6408 13.9167 8.83333C13.9167 6.02589 11.6408 3.75 8.83333 3.75ZM2.25 8.83333C2.25 5.19746 5.19746 2.25 8.83333 2.25C12.4692 2.25 15.4167 5.19746 15.4167 8.83333C15.4167 10.381 14.8826 11.804 13.9887 12.928L17.5303 16.4697C17.8232 16.7626 17.8232 17.2374 17.5303 17.5303C17.2374 17.8232 16.7626 17.8232 16.4697 17.5303L12.928 13.9887C11.804 14.8826 10.381 15.4167 8.83333 15.4167C5.19746 15.4167 2.25 12.4692 2.25 8.83333Z" 
                fill={props.color ? props.color: "white"} />
        </SvgStyled>
    );
};

export default Search_md;
